import { render, staticRenderFns } from "./ItemAdminKPIs.vue?vue&type=template&id=fc9104f6&scoped=true&"
import script from "./ItemAdminKPIs.vue?vue&type=script&lang=js&"
export * from "./ItemAdminKPIs.vue?vue&type=script&lang=js&"
import style0 from "./ItemAdminKPIs.vue?vue&type=style&index=0&id=fc9104f6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc9104f6",
  null
  
)

export default component.exports